import { useEditor } from "@tiptap/react";
import { Box } from "@oneloop/jopijs";
import extensions from "./extensions";
import WysiwygEditorContext, {
  EditorCompound,
  ToolbarCompound,
} from "./compound";
import styles from "./styles.module.scss";
import "./reset.scss";

const INITIAL_CONTENT = "";

/**
 * WysiwygEditor component that provides a rich text editor using TipTap.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.onChange - Callback function to handle content changes in the editor.
 * @param {React.ReactNode} props.children - Child components to be rendered within the editor context.
 * @returns {JSX.Element|null} The rendered WysiwygEditor component or null if the editor is not initialized.
 */
export default function WysiwygEditor({
  onChange,
  children,
  defaultContent = "",
}) {
  const editorTipTap = useEditor({
    extensions,
    content: INITIAL_CONTENT || defaultContent,
    onUpdate: ({ editor }) => {
      if (onChange) onChange(editor.getHTML());
    },
    immediatelyRender: false,
  });

  if (!editorTipTap) return null;

  return (
    // eslint-disable-next-line
    <WysiwygEditorContext.Provider value={{ editor: editorTipTap }}>
      <Box className={styles["tiptap-wrapper"]}>{children}</Box>
    </WysiwygEditorContext.Provider>
  );
}

WysiwygEditor.Toolbar = ToolbarCompound;
WysiwygEditor.Editor = EditorCompound;
